<template>
    <div class="mask-loading" @touchmove="preventEvents" v-if="loading">
        <div class="loading-wrap">
            <img class="loading-gif" src="https://resource.rcclchina.com.cn/logo/PC/logoLoadingPc.gif" alt="loading">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading',
        props: {
            loading: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            preventEvents (e) {
                e.preventDefault()
            }
        }
    }
</script>

<style lang="less" scoped>
    .mask-loading{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999999;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
        .loading-wrap{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 210px;
            height: 210px;
            padding: 30px;
            margin-top: -105px;
            margin-left: -105px;
            background-color: #fff;
            border-radius: 35px;
        }
        .loading-gif{
            width: 150px;
            height: 150px;
        }
    }
</style>
